import React from 'react';
import { Text, TextProps } from '@mantine/core';
import { P4Medium as P4MediumStyle } from 'theme/typography';

interface P4MediumProps extends TextProps {
  customStyle?: React.CSSProperties;
  children: React.ReactNode; // Explicitly define the children prop
}

/**
 * Applies the P4Medium typography style.
 */
const P4Medium: React.FC<P4MediumProps> = ({ children, customStyle, ...restProps }) => {
  return (
    <Text {...restProps} style={{ ...P4MediumStyle, ...customStyle }}>
      {children}
    </Text>
  );
};

export default P4Medium;
